import script from "./be.vue?vue&type=script&setup=true&lang=js"
export * from "./be.vue?vue&type=script&setup=true&lang=js"

import "./be.vue?vue&type=style&index=0&id=5cbaea42&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbaea42"]])

export default __exports__